export default "__VITE_ASSET__CtxiXLj8__"